<template>
  <div>
    <div v-if="displayAcceptReject">
      <div v-if="view === acceptReject.Horizontal">
        <div class="btn-group d-flex align-items-center" role="group">
          <button
            type="button"
            class="btn btn-xs btn-success"
            v-on:click="processDelegatedItem(true, $event)"
          >
            Accept
          </button>
          <button
            type="button"
            class="btn btn-xs btn-danger"
            v-on:click="processDelegatedItem(false, $event)"
          >
            Reject
          </button>
        </div>
      </div>

      <div v-if="view === acceptReject.Vertical">
        <div class="mt-2">
          <button class="btn btn-block btn-success" @click="processDelegatedItem(true)">
            <i class="fas fa-check icon-left"></i>
            Accept
          </button>
        </div>

        <div class="mt-2">
          <button class="btn btn-block btn-danger" @click="processDelegatedItem(false)">
            <i class="fas fa-share icon-left"></i>
            Reject
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import {
    BoardItemStatusDto,
    IBoardItemDto,
    IBoardItemListDto,
    ListGroupTypeDto,
  } from '@/apiclient/apiclient_generated';
  import AcceptRejectView from '@/types/acceptRejectView';
  import { BoardModule, BoardStore } from '@/store/board';

  @Component({})
  export default class BoardItemAcceptReject extends Vue {
    @Prop() item: IBoardItemDto;
    @Prop() view: AcceptRejectView;
    @Prop() list: IBoardItemListDto;
    private boardStore: BoardModule = BoardStore;
    private acceptReject = AcceptRejectView;
    private boardItemStatus = BoardItemStatusDto;
    private listGroupType = ListGroupTypeDto;

    get displayAcceptReject() {
      const display =
        this.view === AcceptRejectView.Horizontal
          ? () => {
              return (
                this.list &&
                this.list.listGroupType === this.listGroupType.Delegated &&
                this.item.boardItemStatus === this.boardItemStatus.UnderReview &&
                this.item.isDelegated
              );
            }
          : () => {
              return (
                this.boardStore.currentBoardId === this.item.ownerBoardId &&
                this.item.boardItemStatus === this.boardItemStatus.UnderReview &&
                this.item.isDelegated
              );
            };

      return display();
    }

    async processDelegatedItem(accept, event) {
      if (event) {
        event.stopPropagation();
      }

      await this.boardStore.processDelegatedItem({ boardItemId: this.item.id, accept });

      if (this.view === AcceptRejectView.Vertical) {
        this.$root.$emit('bv::hide::modal', 'taskdetail');
      }
    }
  }
</script>

<style scoped lang="scss"></style>
